import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import classes from '../addScripts.module.scss';
import SelectWithSearch from '../../../../_common/Form/Selects/SelectWithSearch/SelectWithSearch';
import api from '../../../../../api/api';
import accountHelpers from '../../../../../utils/accountHelpers';

const info = [
  {
    name: 'Name',
    path: 'patientName',
    optionWidth: '25%',
  },
  {
    name: 'Date of Birth',
    path: 'patientDob',
    optionWidth: '15%',
  },
  {
    name: 'Phone number',
    path: 'patientPhone',
    optionWidth: '15%',
  },
  {
    name: 'Address',
    path: 'patientAddress',
    optionWidth: '45%',
  },
];

let timeout;

const PatientInfo = ({
  patientInfo, setPatient, error, showInput,
}) => {
  const [patientList, setPatientList] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [loading, setLoading] = useState(false);

  const searchPatient = (value) => {
    setSearchValue(value);
    clearTimeout(timeout);

    setPatientList([]);

    if (value.trim()) {
      setLoading(true);

      timeout = setTimeout(async () => {
        const { data: { data: { response } } } = await api.getPatients({
          name: value, userId: accountHelpers.getUser().id, limit: 50,
        });

        const patients = response.map((patient) => ({
          PatientId: patient.id,
          patientName: `${patient?.firstName} ${patient?.lastName}`,
          patientDob: moment(patient.dob).isValid() ? moment(patient.dob).format('MM.DD.YYYY') : '-',
          patientPhone: patient.phone,
          patientAddress: _.compact([patient?.addressStreet, patient?.addressCity, patient?.addressState, patient?.addressZipCode]).join(', '),
          patientAddressStreet: patient.addressStreet,
          patientAddressCity: patient.addressCity,
          patientAddressState: patient.addressState,
          patientZipCode: patient.addressZipCode,
        }));

        setPatientList(patients);
        setLoading(false);
      }, 400);
    } else {
      setLoading(false);
    }
  };

  const selectPatient = (path, option) => {
    setSearchValue('');
    setPatientList([]);

    if (option) {
      setPatient(path, option);
    }
  };

  return (
    <div className={classes.patient_wrapper}>
      <h4>Patient</h4>

      {showInput && (
        <SelectWithSearch
          label="Search"
          wrapperClassName={classes.patient_search}
          searchValue={searchValue}
          onChange={(value) => searchPatient(value)}
          options={patientList}
          loading={loading}
          tableOption={info}
          clearValueAfterSelect
          error={error}
          optionKey=""
          onSelectOption={(option) => selectPatient('patient', option)}
        />
      )}

      <table className={classes.table}>
        <thead>
          <tr>
            {info.map(({ name }) => (
              <th key={name}>{name}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          <tr>
            {info.map(({ path }) => (
              <td key={path}>{patientInfo[path] || '-'}</td>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

PatientInfo.propTypes = {
  patientInfo: PropTypes.object.isRequired,
  error: PropTypes.string,
  setPatient: PropTypes.func.isRequired,
  showInput: PropTypes.bool.isRequired,
};

PatientInfo.defaultProps = {
  error: '',
};

export default PatientInfo;
